/**
 * getAccountNbrName function retrieves the account number and name from session storage or a provided account object.
 * It returns an object containing the account number, first name, and last name.
 * @param {*} account
 * @returns {Object} - An object containing accountNumber, firstName, and lastName.
 * If the account number is not found, it returns an object with empty strings.
 */
const getAccountNbrName = () => {
  try {
    let gatewayCutomerObject = window.sessionStorage.getItem("GatewayCustomer")
    gatewayCutomerObject = gatewayCutomerObject && typeof gatewayCutomerObject === "string" ? JSON.parse(gatewayCutomerObject) : {}
    const accountNumber = window.sessionStorage.getItem("AccountNumber") || (gatewayCutomerObject?.preferredCustomer?.accountNbr)
    if (accountNumber) {
      return {
        accountNumber,
        userFirstName: window.sessionStorage.getItem("FirstName") || gatewayCutomerObject?.name?.firstName || "Hello",
        userLastName: window.sessionStorage.getItem("LastName") || gatewayCutomerObject?.name?.lastName || "User"
      }
    }
  } catch (error) {
    console.error("Error retrieving account information:", error)
  }
  return {
    accountNumber: "",
    userFirstName: "",
    userLastName: ""
  }
}

export default getAccountNbrName